import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Button } from "./ui/button";
import { Camera, X } from "lucide-react";

/**
 * QR scanner modal. Calls onScan(text) when a code is detected, then auto-closes.
 * Filters codes to wallet code shape (contains "MB-").
 */
export default function QrScanner({ onScan, onClose }) {
  const scannerRef = useRef(null);
  const containerId = "qr-scanner-container";
  const [error, setError] = useState("");

  useEffect(() => {
    const html5 = new Html5Qrcode(containerId);
    scannerRef.current = html5;
    let stopped = false;
    html5
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 240, height: 240 } },
        (decodedText) => {
          if (stopped) return;
          stopped = true;
          html5.stop().then(() => onScan(decodedText)).catch(() => onScan(decodedText));
        },
        () => {}
      )
      .catch((err) => {
        setError("Não foi possível abrir a câmera: " + (err?.message || err));
      });
    return () => {
      if (scannerRef.current && scannerRef.current.isScanning) {
        scannerRef.current.stop().catch(() => {});
      }
    };
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-[200] bg-black/80 flex items-center justify-center p-4" data-testid="qr-scanner-modal">
      <div className="w-full max-w-md bg-white rounded-3xl overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b border-stone-200">
          <div className="flex items-center gap-2 font-display font-semibold text-stone-900">
            <Camera size={18} /> Escanear QR Code da Carteira
          </div>
          <Button variant="ghost" size="icon" onClick={onClose} data-testid="qr-close">
            <X size={18} />
          </Button>
        </div>
        <div className="p-4">
          <div id={containerId} className="w-full aspect-square rounded-2xl overflow-hidden bg-stone-900" />
          {error && <p className="text-xs text-red-600 mt-3">{error}</p>}
          <p className="text-xs text-stone-500 mt-3 text-center">Posicione o QR Code dentro do quadro.</p>
        </div>
      </div>
    </div>
  );
}
